/**
 * Validation constants for billing-related forms.
 * Source of truth: SetArbitraryPriceDto in apps/backend/src/billing/dto/admin-order-write.dto.ts
 */
export const ARBITRARY_PRICE_VALIDATION = {
  MIN_REASON_LENGTH: 20,
  MAX_REASON_LENGTH: 2000,
  /** Amber-counter threshold — warn when 200 chars remain (= MAX - 200). */
  WARN_REASON_LENGTH: 1800,
  MIN_NET_PLN: 0,
} as const;
